<template>
  <ErrorModal />
  <q-dialog v-model="showAddUser" persistent class="add-new-user-dialog">
    <q-card style="min-width: 300px">
      <q-card-section>
        <div>
          <span>
            <i class="las la-2x la-user la-fw"></i>
              Nieuwe gebruiker
          </span>
        </div>
      </q-card-section>

      <q-separator />

      <q-card-section class="q-pt-none">
        <div class="row justify-around">
          <div class="col-md-6">
            <q-input
              class="q-pa-md"
              v-model="user.email"
              filled
              type="email"
              label="Email"
              stack-label
              :rules="[isValidEmail, requiredFieldRule]"
            >
              <template v-slot:prepend>
                <q-icon name="mail" small/>
              </template>
            </q-input>
          </div>
          <div class="col-md-6">
            <q-select
              class="q-pa-md"
              filled
              v-model="user.person.salutation"
              use-input
              input-debounce="0"
              label="Meneer/mevrouw"
              :options="salutationOptions"
              @filter="salutationFilterFn"
              style="width: 250px"
              behavior="menu"
              stack-label
              :rules="requiredFieldRule"
            >
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-grey">
                    No results
                  </q-item-section>
                </q-item>
              </template>
            </q-select>
          </div>
        </div>

        <div class="row justify-around">
          <q-input
            class="q-pa-md"
            dense
            v-model="user.person.firstName"
            label="Voornaam"
            stack-label
            :rules="requiredFieldRule"
          />
          <q-input
            class="q-pa-md"
            dense
            v-model="user.person.lastName"
            label="Achternaam"
            stack-label
            :rules="requiredFieldRule"
          />
        </div>
      </q-card-section>

      <q-separator />

      <q-card-actions align="around">
        <q-btn           
          class="save-btn-q"
          no-caps
          flat
          label="Opslaan" 
          @click="createNewUser()"
        />
        <q-btn 
          no-caps
          flat
          class="cancel-btn"
          outline
          label="Annuleren" 
          @click="disableAddUser()" 
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { ref, onMounted, computed, reactive } from 'vue';
import store from '../../store/index.js';
import { useRouter } from 'vue-router';
import ErrorModal from './ErrorModal.vue';
import UserService from '../../services/userprofile.service';

export default {
  components: {
    ErrorModal,
  },
  setup() {
    const router = useRouter();

    const showAddUser = computed({
      get: () => store.state.user.showAddUser,
    });

    const customerName = computed({
      get: () => store.state.user.customer.name,
    });

    const user = reactive({
      email: '',
      person: {
        firstName: '',
        lastName: '',
        salutation: '',
        customer: customerName
      },
    });

    const salutationOptions = ref(salutations);

    onMounted(() => {
      UserService.getAllSalutations();
    });

    const disableAddUser = () => {
      store.commit('user/disableAddUser');
    };

    const createNewUser = async () => {
      await UserService.addNewUser(user);
      user.email = '';
      user.person.firstName = '';
      user.person.lastName = '';
      user.person.salutation = '';
      disableAddUser();
    };

    const salutations = computed({
      get: () => store.state.user.salutationsList,
    });

    return {
      showAddUser,
      customerName,
      disableAddUser,
      createNewUser,
      user,
      salutations,
      salutationOptions,
      router,
      salutationFilterFn(val, update) {
        if (val === '') {
          update(() => {
            salutationOptions.value = salutations.value;
          });
          return;
        }
        update(() => {
          const needle = val.toLowerCase();
          salutationOptions.value = salutations.value.filter(
            (v) => v.toLowerCase().indexOf(needle) > -1
          );
        });
      },
      requiredFieldRule: [
        (val) => (val && val.length > 0) || 'Veld is verplicht!',
      ],
      isValidEmail(val) {
        const emailPattern = /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
        return emailPattern.test(val) || 'Invalid email';
      },
    };
  },
};
</script>
